export var BusinessUpdateStatus;
(function (BusinessUpdateStatus) {
    BusinessUpdateStatus["Draft"] = "DRAFT";
    BusinessUpdateStatus["Scheduled"] = "SCHEDULED";
    BusinessUpdateStatus["Published"] = "PUBLISHED";
    BusinessUpdateStatus["Unpublished"] = "UNPUBLISHED";
})(BusinessUpdateStatus || (BusinessUpdateStatus = {}));
//# sourceMappingURL=BusinessUpdateStatus.js.map